import { colors } from '../../colors';
var fiveCard = {
  textColor: colors.lead,
  hoverColor: colors.cornflowerBlue,
  bgColorPara: colors.white,
  bgColor: colors.white,
  cardBgColorB: colors.white,
  cardBgColorHoverB: colors.cornflowerBlue,
  cardCTAColorB: colors.lead,
  cardCTAColorHoverB: colors.white,
  iconColor: colors.cornflowerBlue,
  iconColorHover: colors.white
};
export default fiveCard;